import { api } from "@/lib/api";

export const TZ = "America/Los_Angeles";
export const fmtDateTime = (d) => new Date(d).toLocaleString("en-US", { timeZone: TZ, weekday: "long", month: "long", day: "numeric", hour: "numeric", minute: "2-digit" });
export const fmtShort = (d) => new Date(d).toLocaleString("en-US", { timeZone: TZ, month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });
export const fmtTime = (d) => new Date(d).toLocaleTimeString("en-US", { timeZone: TZ, hour: "numeric", minute: "2-digit" });
export const fmtDay = (iso, opts = { weekday: "short", month: "short", day: "numeric" }) => new Date(`${iso}T12:00:00`).toLocaleDateString("en-US", opts);
export const todayIso = () => new Date().toLocaleDateString("en-CA", { timeZone: TZ });
export const addDays = (iso, n) => { const d = new Date(`${iso}T12:00:00`); d.setDate(d.getDate() + n); return d.toLocaleDateString("en-CA"); };
export const mondayOf = (iso) => addDays(iso, -((new Date(`${iso}T12:00:00`).getDay() + 6) % 7));

export const STATUS = {
  requested: { label: "Awaiting Patria confirmation", cls: "border-sage-400 bg-cream-50 text-ink-900" },
  confirmed: { label: "Confirmed", cls: "border-olive-900 bg-olive-900 text-cream-50" },
  offered: { label: "Offered to you", cls: "border-terracotta-600 bg-terracotta-600 text-cream-50" },
  declined: { label: "Not confirmed", cls: "border-sage-400 text-ink-500" },
  cancelled: { label: "Cancelled", cls: "border-sage-400 text-ink-500" },
  late_cancel: { label: "Late cancel", cls: "border-terracotta-600 text-terracotta-600" },
  no_show: { label: "No-show", cls: "border-terracotta-600 text-terracotta-600" },
  completed: { label: "Completed", cls: "border-olive-900 text-olive-900" },
  expired: { label: "Offer expired", cls: "border-sage-400 text-ink-500" },
};

export const WEEKDAYS = [["mon", "Mon"], ["tue", "Tue"], ["wed", "Wed"], ["thu", "Thu"], ["fri", "Fri"], ["sat", "Sat"], ["sun", "Sun"]];
export const TIMES = [["morning", "Mornings"], ["afternoon", "Afternoons"], ["evening", "Evenings"]];
export const DAY_NAMES = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
export const HALF_HOURS = Array.from({ length: 32 }, (_, i) => {
  const h = 6 + Math.floor(i / 2);
  const m = i % 2 ? "30" : "00";
  return [`${String(h).padStart(2, "0")}:${m}`, `${((h + 11) % 12) + 1}:${m} ${h < 12 ? "AM" : "PM"}`];
});
export const hmLabel = (hm) => HALF_HOURS.find(([v]) => v === hm)?.[1] || hm;

export async function downloadIcs(a) {
  const res = await api.get(`/scheduling/appointments/${a.id}/ics`, { responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const link = Object.assign(document.createElement("a"), { href: url, download: `patria-appointment-${a.local_date}.ics` });
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
